import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .SMDSCloseBtn': {
    position: 'absolute',
    zIndex: 1,
    width: theme.spacing(5),
    height: theme.spacing(5),
    backgroundColor: theme.palette.common.white,
    color: theme.palette.secondary.main,
    left: theme.spacing(4),
    top: theme.spacing(2),
    boxShadow: '0px 4px 4px rgb(0 0 0 / 25%)',
    borderRadius: theme.spacing(1),
  },
}));

export default StyledDialog;
